import { gql } from '@apollo/client';
const GET_SPECIFICATION_SUMMARY = gql `
  query GetSpecificationSummary($modelSpecificationId: ID!) {
    node(id: $modelSpecificationId) {
      ... on ModelSpecificationNode {
        id
        fancyName
        itemCode
        description
        productionTimeMinutes
        image
        state
        brand {
          id
          name
        }
        category {
          id
          name
        }
        season {
          id
          name
        }
        status {
          id
          namePL
          nameEN
          color
        }
        tags {
          edges {
            node {
              id
              tag {
                id
                name
              }
            }
          }
        }
        files {
          edges {
            node {
              id
              file
            }
          }
        }
        sharedmodelspecificationSet {
          edges {
            node {
              id
              status
              sharedWith {
                id
                username
                email
              }
            }
          }
        }
        author {
          id
          username
        }
        folder {
          id
          name
          path {
            id
            name
          }
        }
        persons {
          edges {
            node {
              id
              status
              position {
                name
              }
              isAdmin
              user {
                id
                username
                email
                avatar
              }
            }
          }
        }
        specificationTeamMembersNode {
          id
          adminName
          patternerName
          designerName
          productionName
        }
      }
    }
  }
`;
export default GET_SPECIFICATION_SUMMARY;
